

















































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import {
  UserDTO,
  GetClientsRequestSortByEnum,
  GetClientsRequestSortOrderEnum,
} from '@/api';
import { usersModule, rolesModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import UsersEditWindow from './UsersEditWindow.vue';
import UsersCreateWindow from './UsersCreateWindow.vue';

interface usersSearch {
  sortBy?: GetClientsRequestSortByEnum;
  sortOrder?: GetClientsRequestSortOrderEnum;
  STYLIST?: string[];
  STATUS?: string[];
}

@Component({
  name: 'users',
  components: {
    UserMenu,
    MainNavbar,
    UsersEditWindow,
    UsersCreateWindow,
  },
})
export default class Users extends Vue {
  loading = false;

  get users() {
    return usersModule.list;
  }

  async created() {
    usersModule.fetchUsers();
    rolesModule.fetchRoles();
    amplitude.getInstance().logEventWithGroups('Открытие страницы', undefined, 'Пользователи');
  }

  get total() {
    return this.users.length;
  }

  get rolesList() {
    return rolesModule.list;
  }

  getRoles(ids: number[]) {
    return this.rolesList.filter(role => role.id && ids.includes(role.id));
  }

  editUser(user: UserDTO) {
    (this.$refs['user-edit'] as UsersEditWindow).open(user);
    amplitude.getInstance().logEventWithGroups('Открытие редактирования', undefined, 'Пользователи');
  }

  addUser() {
    (this.$refs['user-create'] as UsersCreateWindow).open();
    amplitude.getInstance().logEventWithGroups('Открытие добавления', undefined, 'Пользователи');
  }
}
